/**
 * Normalises an exhibition name for display.
 *
 * Exhibition names are stored inconsistently in the database — some as
 * "YYYY | מחזור X" (year first) and some as "מחזור X | YYYY" (name first).
 * This always renders them name-first, year-last: "מחזור X | YYYY".
 */
export const formatExhibitionName = (name?: string | null): string => {
  if (!name) return '';

  if (name.includes('|')) {
    const parts = name.split('|').map(part => part.trim());
    if (parts.length === 2) {
      const [first, second] = parts;
      // Year stored first -> swap so the Hebrew name leads.
      if (/^\d{4}$/.test(first)) {
        return `${second} | ${first}`;
      }
      // Already name-first (or year second) -> keep order.
      return `${first} | ${second}`;
    }
  }

  return name;
};
